/** @jsx jsx */
import { StaticQuery, graphql } from "gatsby";
import { Grid, Box, jsx } from "theme-ui";
import CategoryBlock from "../ui-elements/category-card/category-card";
import styles from "./category-blocks.style";

const getCategoryData = (edges) => {
  const data = [];
  edges.forEach((category, index) => {
    data.push({
      id: `category-${index}`,
      title: category.node.title,
      thumbnail: category.node.imageSharp.childImageSharp.fluid,
      path: category.node._meta.uid,
    });
  });
  return data;
};

const CategoryBlocks = () => (
  <StaticQuery<GatsbyTypes.Query>
    query={graphql`
      query {
        prismic {
          allCategorys(where: { featured: true }, first: 6) {
            edges {
              node {
                title
                image
                imageSharp {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                _meta {
                  uid
                }
              }
            }
          }
        }
      }
    `}
    render={({ prismic }) => {
      const { allCategorys } = prismic;
      const { edges } = allCategorys;
      const categories = getCategoryData(edges);
      return (
        <Box sx={styles.wrapper}>
          <Grid sx={styles.grid}>
            {categories.map((item) => (
              <CategoryBlock
                key={`category-block--key${item.id}`}
                path={item.path}
                thumbnail={item.thumbnail}
                title={item.title}
              />
            ))}
          </Grid>
        </Box>
      );
    }}
  />
);

export default CategoryBlocks;
